import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CommonService } from '../../../_services';
import { IChangeCallback, ICountry, IGeographicRegion, ICity } from '../../../_entities';
import { PopoverInput } from '../base/popover-input';

@Component({
    selector: 'editable-popover-city-dropdown',
	template: require('./city-dropdown.component.html')
})
export class EditablePopoverCityDropdownComponent extends PopoverInput implements OnInit {

	countryVal: ICountry;
    regionVal: IGeographicRegion;
    cityVal: ICity;

    constructor(private commonService: CommonService) { super(); }

	ngOnInit() {
        this.commonService.getCountries()
            .then(countries => {
                this.countries = [];
                for (let key of Object.keys(countries)) {
                    this.countries.push(countries[key]);
                }
                if (this.premisesLocation) {
                    this.countryVal = this.countries.find(x => x.code == this.premisesLocation.region.country.code);
                }
            });
	}

	@Input('value')
	set setValue(val: any) {
		this.originalValue = val.id;
		this.dirtyValue = val.id;

		this.premisesLocation = val;
		this.onPremisesLocationSet();

	}
  

    @Output() changeCallback = new EventEmitter<IChangeCallback<ICity>>();

    private onPremisesLocationSet() {
        this.loadingInitialValues = true;
        this.invalid = false;
        this.hasUnsavedChanges = false;

        if (this.countries) {
            this.countryVal = this.countries.find(x => x.code == this.premisesLocation.region.country.code);
        }
        this.commonService.getRegionsInCountry(this.premisesLocation.region.country.code)
            .then(regions => {
                this.regions = regions;
                this.regionVal = this.regions.find(x => x.name == this.premisesLocation.region.name);

                this.commonService.getCitiesInRegion(this.region)
                    .then(cities => {
                        this.cities = cities;
                        this.cityVal = this.cities.find(x => x.name == this.premisesLocation.name);

                        this.loadingInitialValues = false;
                    });
            });
    }
    private updateState() {
        this.invalid = !(this.country && this.region && this.city);
        this.hasUnsavedChanges = !(
            this.country && this.country.code == this.premisesLocation.region.country.code
            && this.region && this.region.name == this.premisesLocation.region.name
            && this.city && this.city.name == this.premisesLocation.name
        );
    }

    premisesLocation: ICity;
    countries: ICountry[];
    regions: IGeographicRegion[];
    cities: ICity[];

    set country(val: ICountry) {
        this.countryVal = val;
        this.regions = null;
        this.region = null;

        this.commonService.getRegionsInCountry(this.countryVal.code)
            .then(regions => {
                this.regions = regions;
            });

        this.updateState();
    }
    get country() {
        return this.countryVal;
    }
    set region(val: IGeographicRegion) {
        this.regionVal = val;
        this.cities = null;
        this.city = null;

        if (val) {
            this.commonService.getCitiesInRegion(this.regionVal)
                .then(cities => {
                    this.cities = cities;
                });
        }

        this.updateState();
    }
    get region() {
        return this.regionVal;
    }
    set city(val: ICity) {
        this.cityVal = val;
		this.updateState();

		if (val) {
			this.dirtyValue = val.id;
		} else {
			this.dirtyValue = null;
		}
    }
    get city() {
        return this.cityVal;
	}

	onCancel() {
		this.onPremisesLocationSet();
	}


    loadingInitialValues = false;
    hovering: boolean;
    invalid = true;
    saving: boolean;
    errorMessage: string;
    hasUnsavedChanges: boolean;

    nullValue = null;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/editable-popover/specialized/city-dropdown.component.ts